// extracted by mini-css-extract-plugin
module.exports = {"root":"categoriesSnippet_root__5TYQ6","category":"categoriesSnippet_category__pYdT0","image":"categoriesSnippet_image__RpWa5"};